import { LoadingError } from "vue-utils"

export class HttpLoadingError extends LoadingError {
	readonly statusCode: number
	readonly statusText: string

	constructor(response: Response, message?: string) {
		super(friendlyStatusTexts[response.status] ?? response.statusText, message ?? statusCodeTexts[response.status])

		this.statusCode = response.status
		this.statusText = response.statusText
	}
}

const friendlyStatusTexts: Record<number, string> = {
	400: "Invalid Data Submitted",
	401: "Invalid Login",
	403: "No Permissions",
	404: "Not Found",
	500: "Internal Server Error",
}

const statusCodeTexts: Record<number, string> = {
	400: "There was an issue with the data you submitted. Try again or contact an administrator",
	401: "Please refresh your login and try again",
	403: "You do not have sufficient permissions to perform that action",
	404: "A required value was not found. Try again or contact an administrator",
	500: "An internal server error occurred. Try again or contact an administrator",
}
